import { Select } from 'antd'
import makeField from 'utils/makeField'

export const Option = Select.Option
export const OptGroup = Select.OptGroup

export default makeField(Select)
